<div class="form-container">
    <form *ngIf="createAccountForm" [formGroup]="createAccountForm">
        <!-- Calculation Type -->
        <div class="calculation-type-container">
            <label class="calculation-type-label">Calculation Type <span class="required-asterisk">*</span></label>
            <div class="calculation-type-buttons">
                <button 
                    type="button"
                    class="calc-type-btn"
                    [class.active]="createAccountForm.get('calculationType')?.value === 'BASIC'"
                    [disabled]="isFormDisabled"
                    [ngClass]="{'disabled-style': isFormDisabled}"
                    (click)="selectCalculationType('BASIC')">
                    Layer Exposed
                </button>
                <button 
                    type="button"
                    class="calc-type-btn"
                    [class.active]="createAccountForm.get('calculationType')?.value === 'WITH_DEDUCTIBLE'"
                    [disabled]="isFormDisabled"
                    [ngClass]="{'disabled-style': isFormDisabled}"
                    (click)="selectCalculationType('WITH_DEDUCTIBLE')">
                    Layer Exposed with Deductible
                </button>
            </div>
            <div class="error-message" *ngIf="createAccountForm.controls.calculationType.hasError('required') && createAccountForm.get('calculationType').invalid && (createAccountForm.get('calculationType').dirty || createAccountForm.get('calculationType').touched)">
                Calculation Type is required.
            </div>
        </div>

        <!-- Name Field -->
        <div class="policy-id-container">
            <div class="policy-id-header">
                <label class="policy-id-label">Name <span class="required-asterisk">*</span></label>
            </div>
            <mat-form-field class="full-width">
                <input matInput formControlName="name" name="account-name" autocomplete="off" [disabled]="isFormDisabled" [ngClass]="{'disabled-style': isFormDisabled}" (input)="removeSpaces()"/>
                <mat-error *ngIf="createAccountForm.controls.name.hasError('used') ">
                    Layer Exposed with this name already exists
                </mat-error>
                <mat-error *ngIf="createAccountForm.controls.name.hasError('required') && createAccountForm.get('name').invalid && (createAccountForm.get('name').dirty || createAccountForm.get('name').touched)">
                    Layer Exposed name is required
                </mat-error>
                <mat-error
                    *ngIf="createAccountForm.controls['name'].touched && createAccountForm.controls['name'].hasError('maxlength')">
                    You exceed the maximum number of characters.
                </mat-error>
                <mat-error
                    *ngIf="createAccountForm.controls['name'].touched && createAccountForm.controls['name'].hasError('pattern')">
                    You cannot use special characters. Space is allowed only between words.
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Select TIV Value - LOCATION -->
        <div class="policy-id-container">
            <div class="policy-id-header">
                <label class="policy-id-label">Location TIV or equivalent value <span class="required-asterisk">*</span></label>
            </div>
            <mat-form-field class="full-width">
                <mat-select [ngClass]="{'disabled-style': isFormDisabled}" [disabled]="isFormDisabled" formControlName="tivValue">
                    <mat-option *ngFor="let data of locationTIVFields" [value]="data.id">
                        {{ data.name | decodeHtml }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="createAccountForm.controls.tivValue?.hasError('required') && createAccountForm.get('tivValue')?.invalid && (createAccountForm.get('tivValue')?.dirty || createAccountForm.get('tivValue')?.touched)">
                    TIV Value is required.
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Select Deductible - LOCATION (Only for WITH_DEDUCTIBLE) -->
        <div class="policy-id-container" *ngIf="createAccountForm.get('calculationType')?.value === 'WITH_DEDUCTIBLE'">
            <div class="policy-id-header">
                <label class="policy-id-label">Location deductible %</label>
            </div>
            <mat-form-field class="full-width">
                <mat-select [ngClass]="{'disabled-style': isFormDisabled}" [disabled]="isFormDisabled" formControlName="deductible">
                    <mat-option *ngFor="let data of locationDatasetDropdown" [value]="data.id">
                        {{ data.name | decodeHtml }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Select Limit - POLICY -->
        <div class="policy-id-container">
            <div class="policy-id-header">
                <label class="policy-id-label">Policy / Contract limit <span class="required-asterisk">*</span></label>
            </div>
            <mat-form-field class="full-width">
                <mat-select [ngClass]="{'disabled-style': isFormDisabled}" [disabled]="isFormDisabled" formControlName="layerValue">
                    <mat-option *ngFor="let data of policyDatasetDropdown" [value]="data.id">
                        {{ data.name | decodeHtml }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="createAccountForm.controls.layerValue?.hasError('required') && createAccountForm.get('layerValue')?.invalid && (createAccountForm.get('layerValue')?.dirty || createAccountForm.get('layerValue')?.touched)">
                    Limit is required.
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Select Minimum Deductible - POLICY (Only for WITH_DEDUCTIBLE) -->
        <div class="policy-id-container" *ngIf="createAccountForm.get('calculationType')?.value === 'WITH_DEDUCTIBLE'">
            <div class="policy-id-header">
                <label class="policy-id-label">Policy min. deductible</label>
            </div>
            <mat-form-field class="full-width">
                <mat-select [ngClass]="{'disabled-style': isFormDisabled}" [disabled]="isFormDisabled" formControlName="minimumDeductible">
                    <mat-option [value]="'NONE'">None</mat-option>
                    <mat-option *ngFor="let data of policyMinimumDeductibleFields" [value]="data.id">
                        {{ data.name | decodeHtml }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Select Maximum Deductible - POLICY (Only for WITH_DEDUCTIBLE) -->
        <div class="policy-id-container" *ngIf="createAccountForm.get('calculationType')?.value === 'WITH_DEDUCTIBLE'">
            <div class="policy-id-header">
                <label class="policy-id-label">Policy max. deductible</label>
            </div>
            <mat-form-field class="full-width">
                <mat-select [ngClass]="{'disabled-style': isFormDisabled}" [disabled]="isFormDisabled" formControlName="maximumDeductible">
                    <mat-option [value]="'NONE'">None</mat-option>
                    <mat-option *ngFor="let data of policyMaximumDeductibleFields" [value]="data.id">
                        {{ data.name | decodeHtml }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Select Attachment Point - POLICY -->
        <div class="policy-id-container">
            <div class="policy-id-header">
                <label class="policy-id-label">Policy / Contract attachment point <span class="required-asterisk">*</span></label>
            </div>
            <mat-form-field class="full-width">
                <mat-select [ngClass]="{'disabled-style': isFormDisabled}" [disabled]="isFormDisabled" formControlName="attachmentPoint">
                    <mat-option *ngFor="let data of policyDatasetDropdown" [value]="data.id">
                        {{ data.name | decodeHtml }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="createAccountForm.controls.attachmentPoint?.hasError('required') && createAccountForm.get('attachmentPoint')?.invalid && (createAccountForm.get('attachmentPoint')?.dirty || createAccountForm.get('attachmentPoint')?.touched)">
                    Attachment Point is required.
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Select Participation % - POLICY -->
        <div class="policy-id-container">
            <div class="policy-id-header">
                <label class="policy-id-label">Policy / Contract participation % <span class="required-asterisk">*</span></label>
            </div>
            <mat-form-field class="full-width">
                <mat-select [ngClass]="{'disabled-style': isFormDisabled}" [disabled]="isFormDisabled" formControlName="participation">
                    <mat-option *ngFor="let data of policyDatasetDropdown" [value]="data.id">
                        {{ data.name | decodeHtml }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="createAccountForm.controls.participation?.hasError('required') && createAccountForm.get('participation')?.invalid && (createAccountForm.get('participation')?.dirty || createAccountForm.get('participation')?.touched)">
                    Participation % is required.
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Select Layer Exposed Calculation Display Breakdown field - POLICY (Required) -->
        <div class="policy-id-container">
            <div class="policy-id-header">
                <label class="policy-id-label" matTooltip="The field to use for display breakdown (e.g., Policy ID, Contract ID)" matTooltipPosition="above">
                    Layer Exposed Calculation Display Breakdown field <span class="required-asterisk">*</span>
                    <div class="helper-text">(Policy / Contract ID or equivalent field)</div>
                </label>
            </div>
            <mat-form-field class="full-width">
                <mat-select [ngClass]="{'disabled-style': isFormDisabled}" [disabled]="isFormDisabled" formControlName="policyIdPolicy">
                    <mat-option *ngFor="let data of policyIdFields" [value]="data.id">
                        {{ data.name | decodeHtml }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="createAccountForm.controls.policyIdPolicy?.hasError('required') && createAccountForm.get('policyIdPolicy')?.invalid && (createAccountForm.get('policyIdPolicy')?.dirty || createAccountForm.get('policyIdPolicy')?.touched)">
                    This field is required.
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Select additional Display Breakdown field - LOCATION -->
        <div class="policy-id-container">
            <div class="policy-id-header">
                <label class="policy-id-label" matTooltip="Additional field for breakdown (e.g., Client, Insured)" matTooltipPosition="above">
                    Additional Display Breakdown field
                    <div class="helper-text">(Client / Insured or equivalent field)</div>
                </label>
            </div>
            <mat-form-field class="full-width">
                <mat-select [ngClass]="{'disabled-style': isFormDisabled}" [disabled]="isFormDisabled" formControlName="client">
                    <mat-option *ngFor="let data of locationClientFields" [value]="data.id">
                        {{ data.name | decodeHtml }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div *ngIf="true" style="display: flex; gap: 10px; align-items: center;justify-content: space-evenly; margin-top: 12px;">
            <button [ngClass]="{'disabled-style': isFormDisabled}" mat-flat-button color="accent" style="border-radius: 5px;padding:0px 230px;font-size: 43px;" (click)="submitLayerExpose()" [disabled]="isFormDisabled">Save
            </button>
        </div>

    </form>

</div>
